import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    num: "01",
    q: "Who is eligible to fight under the MPB banner?",
    a: "Any fighter aged 40–55 — professionals with a recorded pro record (W-L-D) and freshers starting from 0-0-0. Every application is reviewed by the MPB sanctioning committee before licensure.",
  },
  {
    num: "02",
    q: "What are the official round and glove rules?",
    a: "Masters division bouts are contested over shorter championship formats with larger, safer gloves as mandated by the medical protocol. Exact round and glove specifications are issued with your fight contract.",
  },
  {
    num: "03",
    q: "Which medical clearances are mandatory?",
    a: "Cardiac screening, neurological assessment, MRI/CT clearance and a ringside physical exam are mandatory for every fighter before any sanctioned bout. No clearance, no fight.",
  },
  {
    num: "04",
    q: "How does matchmaking parity work?",
    a: "Your record, age and activity level are scored against our parity standard so veterans face veterans of comparable experience — freshers are never matched against seasoned professionals.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-24 lg:py-32 border-t border-zinc-800/60" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <motion.p
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-mono2 text-[10px] sm:text-xs tracking-[0.4em] text-zinc-400 uppercase mb-4 flex items-center gap-4"
        >
          <span className="h-px w-10 bg-[#E10600]" /> Questions
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] text-white mb-12"
        >
          Before you <span className="text-[#E10600]">lace up</span>
        </motion.h2>

        <Accordion type="single" collapsible>
          {FAQS.map((f, i) => (
            <motion.div
              key={f.num}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.08, duration: 0.6 }}
            >
              <AccordionItem value={f.num} className="border-zinc-800">
                <AccordionTrigger
                  data-testid={`faq-trigger-${f.num}`}
                  className="hover:no-underline py-6 text-left gap-4"
                >
                  <span className="flex items-baseline gap-4 sm:gap-6">
                    <span className="font-mono2 text-xs text-[#E10600]">{f.num}</span>
                    <span className="font-cond font-bold text-xl sm:text-2xl uppercase tracking-wide text-white">
                      {f.q}
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-sm sm:text-base leading-relaxed pl-9 sm:pl-12 pb-6" data-testid={`faq-content-${f.num}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
